/**
 * Created by Xuz on 2020/01/08.
 * xuz@live.cn
 *
 * 工作流常量定义
 */

// 主要是拖动时的控制
export const iToolbarWidth = 60

export const iToolbarHeight = 42

// 高度控制
export const iCanvasMaxTop = 30

// 画板的最宽度;在开始后其会自动修正
export const iCanvasMaxWidth = 1200

// 画板的最高可用度 在开始后其会自动修正
export const iCanvasMaxHeight = 600

// 添加
export const WF_OPERATION_ADD = 1

// 编辑
export const WF_OPERATION_EDIT = 2

// 流程跟踪
export const WF_OPERATION_TRACKER = 6

// 编辑模式
export const WF_PROCESS_STATE_EDITING = 'E'

// 使用模式
export const WF_PROCESS_STATE_USING = 'U'

// -------------------- 节点类型 -------------------- //

// 普通节点
export const NODE_TYPE_COMMON_NODE = 1
// 开始节点
export const NODE_TYPE_START_NODE = 2
// 结束节点
export const NODE_TYPE_END_NODE = 3
// 转换节点
export const NODE_TYPE_TRANS_NODE = 5

// XML的节点常量类型定义
export const XML_DF_ELEMENT_NODE = 1
export const XML_DF_ATTRIBUTE_NODE = 2
export const XML_DF_TEXT_NODE = 3
export const XML_DF_CDATA_SECTION_NODE = 4
export const XML_DF_ENTITY_REFERENCE_NODE = 5
export const XML_DF_ENTITY_NODE = 6
export const XML_DF_PROCESSING_INSTRUCTION_NODE = 7
export const XML_DF_COMMENT_NODE = 8
export const XML_DF_DOCUMENT_NODE = 9
export const XML_DF_DOCUMENT_TYPE_NODE = 10
export const XML_DF_DOCUMENT_FRAGMENT_NODE = 11
export const XML_DF_NOTATION_NODE = 12

export const FLOW_TYPE = [
  { value: 'E', label: '一般的电子送件' },
  { value: 'H', label: '会签送件' },
  { value: 'I', label: '会签送件(非等待)' },
  { value: 'Y', label: '传阅送件' },
  { value: 'P', label: '纸质送件' },
  { value: 'T', label: '批量送件' },
  { value: 'C', label: '并发送件' },
  { value: 'D', label: '并发送件(非等待)' }
]

// 送件时选择指定收件人
export const SEND_OBJECT_TYPE_USER = '1'

// 送件时选择指定岗位
export const SEND_OBJECT_TYPE_POS = '0'

// 送件时到本机构指定岗位
export const SEND_OBJECT_TYPE_LOCAL_POS = '5'

// 送件时到本部门指定岗位
export const SEND_OBJECT_TYPE_LOCAL_DEPT_POS = 'Z'

// 送件时选择指定角色本机构
export const SEND_OBJECT_TYPE_ROLE = '2'

// 送件时选择指定角色全机构
export const SEND_OBJECT_TYPE_ROLE_ALL_ORG = 'J'

// 送件时选择指定部门
export const SEND_OBJECT_TYPE_DEPT = '3'

// 送件时到本机构指定部门
export const SEND_OBJECT_TYPE_LOCAL_DEPT = '4'

// 送件时选择流程之前的执行人
export const SEND_OBJECT_TYPE_ROUTE = 'R'

// 送件时可自由选择整个组织架构中的任何人
export const SEND_OBJECT_TYPE_ALL_USER = '9'

// -------------------- 节点特性 -------------------- //
// 特性节点 - 环开始
export const WF_ACTIVITY_SPECIAL_TYPE_CIRCLE_START = 'X'

// 特性节点 - 环结束
export const WF_ACTIVITY_SPECIAL_TYPE_CIRCLE_END = 'Y'
